import { ColumnType } from 'antd/es/table'
import { Popover, Space, Image } from 'antd'
import Stamp from '../../../../types/api/stamp'
import Edit from '../components/table/edit'
import Reorder from '../components/table/reorder'
import getTeeth from '../../../../helpers/fields-calculation/stamps/get-teeth'
import getMaxWidthOfMaterial from '../../../../helpers/fields-calculation/stamps/get-max-width-of-material'
import getNumberOfLabelsInFlood from '../../../../helpers/fields-calculation/stamps/get-number-of-labels-in-flood'
import { formatRollerDisplay } from '../../../../helpers/format-roller-display'

export const columns: ColumnType<Stamp>[] = [
    {
        dataIndex: 'number',
        title: 'Штамп',
        // width: 80, // without compact
        width: 60,
        fixed: 'left',
        render: (value, record) => {
            const content = (
                <>
                    <p>{/* Стоимость: <b>{record.cost}</b> */}</p>
                    <Image width={150} src={record.imageLink} />
                </>
            )
            const title = 'Другая информация'

            return (
                <Popover placement={'rightTop'} title={title} content={content}>
                    {value}
                </Popover>
            )
        },
    },
    {
        dataIndex: 'width',
        title: 'Ширина',
        // width: 90, // without compact
        width: 70,
    },
    {
        dataIndex: 'length',
        title: 'Длина',
        // width: 80, // without compact
        width: 60,
    },
    {
        dataIndex: 'floods',
        title: 'Ручьи',
        // width: 80, // without compact
        width: 60,
    },
    {
        dataIndex: ['roller', 'roller'],
        title: 'Вал',
        // width: 80, // without compact
        width: 100,
        render: (v: number) => formatRollerDisplay(v),
    },
    {
        dataIndex: 'range',
        title: 'Расстояние',
        // width: 120, // without compact
        width: 100,
    },
    {
        dataIndex: 'teeth',
        title: 'Зубья',
        // width: 76, // without compact
        width: 60,
        render(v, record) {
            return getTeeth(record.roller)
        },
    },
    {
        dataIndex: 'maxWidth',
        title: 'Макс. шир.',
        // width: 110, // without compact
        width: 86,
        render(v, record) {
            return getMaxWidthOfMaterial(record)
        },
    },
    {
        dataIndex: 'numberOfLabelsInFlood',
        title: 'Кол-во в 1 р.',
        // width: 110, // without compact
        width: 90,
        render(v, record) {
            return getNumberOfLabelsInFlood({
                roller: record.roller?.roller,
                range: record.range,
                length: record.length,
            })
        },
    },
    {
        dataIndex: 'radius',
        title: 'Радиус',
        // width: 110, // without compact
        width: 65,
    },
    {
        dataIndex: 'shape',
        title: 'Форма',
        // width: 140, // without compact
        width: 130,
    },
    {
        dataIndex: 'material_groups',
        title: 'Материалы',
        // width: 110, // without compact
        width: 130,
        render(v: Stamp['material_groups'] = []) {
            return v.map(x => x.name).join(', ')
        },
    },
    {
        dataIndex: ['contractor', 'name'],
        title: 'Производитель',
        // width: 82, // without compact
        width: 100,
    },
    {
        dataIndex: 'externalId',
        title: 'Номер Koher',
        // width: 82, // without compact
        width: 80,
    },
    {
        dataIndex: 'quantity',
        title: 'Кол-во',
        // width: 82, // without compact
        width: 60,
    },
    {
        dataIndex: 'locked',
        title: 'Блокировка',
        // width: 82, // without compact
        width: 100,
        render(v) {
            return v ? 'Не использовать!' : ''
        },
    },
    // {
    //     dataIndex: 'manager',
    //     title: 'Менеджер',
    //     // width: 130, // without compact
    //     width: 130,
    //     render: (_, record: Stamp) => {
    //         return <>manager</>
    //     },
    // },
    {
        dataIndex: 'comment',
        title: 'Примечание',
        // width: 120, // without compact
        width: 120,
    },
    {
        dataIndex: '1',
        title: 'Действия',
        fixed: 'right',
        // width: 100, // without compact
        width: 80,
        render: (_, record: Stamp) => {
            return (
                <Space>
                    <Edit stampDocId={record.documentId} />
                    <Reorder stampDocId={record.documentId} />
                </Space>
            )
        },
    },
]
